import React from "react";
import { createRoot } from "react-dom/client";
import AppRouter from "./router/appRouter";
import "./index.css";
import "antd/dist/reset.css";
import reportWebVitals from "./reportWebVitals";
import { UserProvider } from "./assets/UserContext"; // 导入UserProvider

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <UserProvider>
      <AppRouter />
    </UserProvider>
  </React.StrictMode>
);
reportWebVitals();
